<template>
  <div class="pa-40">
    <h1 class="has-text-weight-bold is-size-4 has-text-primary mb-20">
      {{title}}
    </h1>
    <div class="big-map-recap">
      <gmap-map
        :center="center"
        :zoom="zoom"
        :options="{ mapTypeControlOptions: mapType }"
        @zoom_changed="getZoom = $event"
        @tilesloaded="actionMapIsLoaded"
        ref="mapCartoGeneral"
        class="googleMap">
        <div v-if="mapLoad && mountedLoad">
          <!-- Marker du point de vente enregistré -->
          <gmap-marker
            v-if="pointDeVenteAvecMarker"
            :position="pointDeVenteAvecMarker.coordonnees"
            :icon="pointDeVenteAvecMarker.iconMarker">
          </gmap-marker>

          <!-- Marker panneau -->
          <gmap-marker
            v-for="(item) in markersPanneaux"
            :key="item.idMarker"
            :position="item.adresse.coordonnees"
            :icon="item.icon">
          </gmap-marker>
        </div>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ZOOM_DEFAULT,
  CENTER_DEFAULT,
  STYLE_MAPS_POI_HIDDEN,
  MAP_TYPE_CONTROL_OPTIONS,
  MAP_TYPE_NAME,
} from '@/configuration/configurationCarte';
import {
  getIconPdvData,
  iconMarkerInfoBulle,
} from '@/services/gestionIcon/iconColorGetter';
import { LISTE_CATEGORIES_HONORAIRE, COULEUR_PANNEAU_SOUS_CONTRAT } from '@/configuration/configPanneau';
import { cloneDeep } from 'lodash';
import { adressFullStringGetter } from '@/services/general/general';

const User = createNamespacedHelpers('user');

export default {
  props: {
    recomDevis: Object,
    panneaux: {
      type: Array,
      default: () => [],
    },
    pointDeVente: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      zoom: ZOOM_DEFAULT,
      center: CENTER_DEFAULT,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      markersPanneaux: [],
      mountedLoad: false,
      mapLoad: false,
      getZoom: 0,
      iconsBulle: null,
      pointDeVenteAvecMarker: null,
    };
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    title() {
      if (!this.pointDeVente) return '';
      return `${this.pointDeVente.nomCommercial} - ${adressFullStringGetter(this.pointDeVente.adressePostale)}`;
    },
  },
  methods: {
    async genererPdvAvecMarker() {
      if (!this.pointDeVente) return null;
      const { icon, srcImg, adressePostale } = this.pointDeVente;
      const resIcon = await getIconPdvData(icon || srcImg);
      if (!adressePostale.latitude || !adressePostale.longitude) return null;
      return {
        icon,
        srcImg,
        iconMarker: resIcon.icon,
        coordonnees: {
          lat: adressePostale.latitude,
          lng: adressePostale.longitude,
        }
      };
    },
    async fitBounds() {
      if (!this.pointDeVenteAvecMarker) return;
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(this.pointDeVenteAvecMarker && this.pointDeVenteAvecMarker.coordonnees);
      if (this.markersPanneaux.length) {
        this.markersPanneaux.forEach(el => {
          bounds.extend(el.adresse.coordonnees);
        })
      }
      this.$refs.mapCartoGeneral.fitBounds(bounds);
      const map = await this.$refs.mapCartoGeneral.$mapPromise;
      map.setZoom(this.getZoom - 1);
    },
    async levelZoom() {
      await this.$refs.mapCartoGeneral.$mapPromise;
      await this.fitBounds();
    },
    async getIconPanneau(pan, index) {
      const panneauCopy = cloneDeep(pan);
      const color = (pan.estPanneauSousContrat || pan.estRenouvellement) ? COULEUR_PANNEAU_SOUS_CONTRAT : pan.categorie.couleur;
      panneauCopy.icon = await iconMarkerInfoBulle(color, pan.azimut, index + 1);
      return panneauCopy;
    },
    async getPannneauxWithIconBulle() {
      let data = this.panneaux;
      if (!this.panneaux.some(p => p.estPanneauSousContrat && p.actif)) {
        data = data.filter(p => !p.estPanneauSousContrat);
      }
      const promises = data
        .filter(p => p.categorie && !LISTE_CATEGORIES_HONORAIRE.includes(p.categorie.libelle) && p.actif)
        .map((p, i) => this.getIconPanneau(p, i));
      let res = await Promise.all(promises);
      res = res.filter(p => p.adresse.coordonnees.lat && p.adresse.coordonnees.lng);
      return res;
    },
    async actionMapIsLoaded() {
      if (!this.mapLoad) {
        const styleMap = new google.maps.StyledMapType(
          STYLE_MAPS_POI_HIDDEN,
          { name: MAP_TYPE_NAME },
        );
        this.$refs.mapCartoGeneral.$mapPromise.then((map) => {
          map.mapTypes.set("styled_map", styleMap);
        });
        await this.levelZoom();
        this.mapLoad = true;
      }
    }
  },
  async mounted() {
    this.pointDeVenteAvecMarker = await this.genererPdvAvecMarker();
    this.markersPanneaux = await this.getPannneauxWithIconBulle();
    await this.levelZoom();
    this.mountedLoad = true;
  },
}
</script>
